/***
 * Created on 2023/8/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import trustedDeviceSvg from "../../../../static/img/security/trusted-device.svg";
import {useTranslation} from "react-i18next";

function EmpyTrustedDevice(props) {
    const {t} = useTranslation();

    return (
        <section className="two-step--init">
            <header>{t('@Trusted Devices and Computers@')}</header>
            <article className="comp-content-wrapper">
                <div className="two-step--init__col-left">
                    <div
                        className="two-step--init__col-left__desc">{t('@You can access your account from a trusted computer without needing a verification code.@')}
                    </div>
                    <div
                        className="text-14 !mt-8 color-dark-gray">{t('@There are no trusted devices registered. You can change this during sign in where you can tell us not to ask for a code on specific device.@')}
                    </div>
                </div>
                <div className="two-step--init__col-right"><img src={trustedDeviceSvg} alt=""/></div>
            </article>
        </section>
    );
}

export default EmpyTrustedDevice;